<div class="flex justify-between items-center border-y md:border-t-0">
  <div class="relative">
    <div
      class="rounded-lg p-3 cursor-pointer flex items-center"
      title="Sortieren"
      (click)="updateOpenSection()"
      [class.white-icon]="openSection() === 'sort'"
      [class.!bg-cp-primary-100]="openSection() === 'sort'"
    >
      <mat-icon svgIcon="cp-sort" />
    </div>
    @if (openSection() === 'sort') {
      <div class="box flex flex-col gap-4 bg-cp-contrast-light-100 my-6">
        <div class="flex justify-between">
          <strong>Sortieren nach</strong>
          <mat-icon svgIcon="cp-sort" class="cursor-pointer" (click)="toggleDescending.emit()" />
        </div>
        <div class="border border-solid border-cp-primary-20 p-4">
          <mat-radio-group class="flex flex-col" aria-label="Sortierung" [value]="selected()">
            @for (option of sortOptions(); track option) {
              <mat-radio-button [value]="option" (change)="sortChanged.emit(option)">
                {{ option }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      </div>
    }
  </div>

  <div class="hidden md:flex md:justify-between text-base font-bold">
    @if (expectedErgebnisse()) {
      {{ currentErgebnisse() }} / {{ expectedErgebnisse() }}
      <div class="mr-6 ml-1 font-bold">Ergebnisse</div>
    }
    <div class="underline cursor-pointer" (click)="openSortInfoDialog()">
      So sortieren wir Ergebnisse
    </div>
  </div>

  <div class="lg:hidden flex justify-between items-center">
    <mat-icon
      svgIcon="cp-filter"
      class="!h-6 !w-6 mr-6 cursor-pointer"
      aria-label="Filtern"
      (click)="filterRequested.emit()"
    />
    <div class="mr-6 font-bold">Filtern</div>
  </div>
</div>
